
<app-header *ngIf="!isLoginPage() && !isForgotPage() && !isResetPage()" [alertCount]="alertCount" ></app-header>
<app-loading-spinner *ngIf="_loading.loadingState()" [diameter]="80" [strokeWidth]="8" ></app-loading-spinner>
<section class="main-wrapper login-wrap" >
  <div class="container">
  <router-outlet></router-outlet>
  </div>
</section> 
